module.exports = __webpack_public_path__ + "img/cuff_width.a16753e1.png";